export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.JPG" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h2 className="skills-section--heading">About Me</h2>
          <div className="about--content">
            <p className="hero--section-description">
              I'm a Computer Science graduate from Brigham Young University (Class of 2025, GPA 3.87), currently working as a Software Developer at More Good Foundation where I lead the development of "Lia" — a production-ready AI web application. I specialize in full-stack development with expertise in React, TypeScript, Node.js, and AI technologies including LangChain, RAG, and LLMs.
            </p>
            <p className="hero--section-description">
              I believe in the power of teamwork and effective communication. As a hard worker, self-motivated individual, and quick learner, I'm always eager for new opportunities. I have experience across web, mobile, and cloud development with a strong foundation in AWS, Supabase, and MongoDB.
            </p>
            <div className="about--highlights">
              <div className="highlight--item">
                <span className="highlight--icon">🎓</span>
                <span className="highlight--text">B.S. Computer Science — BYU, Graduated April 2025 (GPA: 3.87)</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🏆</span>
                <span className="highlight--text">Larry R. & Academic Full Scholarship Recipient</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">💼</span>
                <span className="highlight--text">Software Developer at More Good Foundation (July 2024 – Present)</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🤖</span>
                <span className="highlight--text">AI/ML: LangChain, RAG, Prompt Engineering, LLMs</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🎵</span>
                <span className="highlight--text">Musician — Piano, Violin, Harmonica</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🌍</span>
                <span className="highlight--text">Fluent in English, Cantonese, and Mandarin</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
